import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersBookBlock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={62} height={54} fill="none" {...props}>
      <path
        stroke="url(#TiersBookBlock_svg__a)"
        strokeWidth={5}
        d="M37 6.5a22.42 22.42 0 0 1 15.91 6.59A22.42 22.42 0 0 1 59.5 29c0 12.426-10.074 22.5-22.5 22.5a22.42 22.42 0 0 1-15.91-6.59A22.42 22.42 0 0 1 14.5 29C14.5 16.574 24.574 6.5 37 6.5Z"
      />
      <path
        stroke="#0C1C43"
        strokeLinecap="square"
        d="M33.91 24.371V23m6.18 1.371V23m-6.18 4.114h6.18M33.183 35h7.636C42.023 35 43 34.079 43 32.943v-6.514c0-1.137-.977-2.058-2.182-2.058h-7.636c-1.205 0-2.182.921-2.182 2.058v6.514c0 1.136.977 2.057 2.182 2.057Z"
      />
      <path
        fill="#B01921"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <defs>
        <linearGradient
          id="TiersBookBlock_svg__a"
          x1={37}
          x2={36.785}
          y1={4}
          y2={41.767}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FCBDC1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersBookBlock);
export default ForwardRef;
